import axios from "axios";

const API_URL = process.env.REACT_APP_API_KEY;

const putInstituicao = async (
  token: string,
  cnpj: string,
  nome: string,
  email: string,
  telefone: string,
  cep: string,
  estado: string,
  cidade: string,
  bairro: string,
  rua: string,
  numero: string,
  complemento?: string
) => {
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const response = await axios.put(
    `${API_URL}/instituicoes/${cnpj}`,
    {
      nome,
      cnpj,
      email,
      telefone,
      cep,
      cidade,
      estado,
      bairro,
      rua,
      numero,
      complemento,
    },
    config
  );
  return response.data;
};
export default putInstituicao;
